module.exports = __webpack_public_path__ + "img/Pop-up_05.db3f0a70.png";